//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { drawCircles } from '../static/js/createCircles.js'
export default {
  data() {
    return {
      canvasWidth: 0,
      canvasHeight: 0,
      imageUrl: '',
      buttonEnabled: true,
    }
  },
  mounted() {
    this.setCanvasSize()
  },
  methods: {
    setCanvasSize() {
      const canvasContainerWidth = this.$refs.canvasContainer.offsetWidth
      const calculatedWidth = canvasContainerWidth
      this.setCanvasWidth(calculatedWidth)
      this.setCanvasHeight(calculatedWidth * 1.5)
    },
    setCanvasWidth(w) {
      this.canvasWidth = w
    },
    setCanvasHeight(h) {
      this.canvasHeight = h
    },
    drawCircles(type) {
      if (!this.buttonEnabled) {
        return
      }
      this.extension = type
      this.buttonEnabled = false
      drawCircles(this.saveImage, 'jpg')
    },
    saveImage(dataUrl) {
      this.buttonEnabled = true
      this.imageUrl = dataUrl
    },
  },
}
